export default __webpack_public_path__ + "static/media/pahChokiThumb.7f73ba93.png";